import coverImg from "assets/images/v120/cover.webp"
import titleImg from "assets/images/v120/title.webp"

export const v120Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
